/*
import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "./UtilsCalendar.css";
import serverConfig from "../config";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function UtilsCalendar() {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [eventsCalendar, setEventsCalendar] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .post(`${serverConfig.serverUrl}/get_events_calendar`, {
        year: currentDate.getFullYear(),
        month: currentDate.getMonth() + 1,
      })
      .then((response) => {
        const data = response.data;
        setEventsCalendar(data);
      })
      .catch((error) => {});
  }, [currentDate]);

  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    return new Date(year, month + 1, 0).getDate();
  };

  const getFirstDayOfMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    return (new Date(year, month, 1).getDay() + 6) % 7;
  };

  const getMonthData = () => {
    const daysInMonth = getDaysInMonth(currentDate);
    const firstDayOfMonth = getFirstDayOfMonth(currentDate);
    const days = [];

    for (let i = 0; i < firstDayOfMonth; i++) {
      days.push(null);
    }

    for (let day = 1; day <= daysInMonth; day++) {
      days.push(day);
    }

    return days;
  };

  const monthNames = [
    "Gennaio",
    "Febbraio",
    "Marzo",
    "Aprile",
    "Maggio",
    "Giugno",
    "Luglio",
    "Agosto",
    "Settembre",
    "Ottobre",
    "Novembre",
    "Dicembre",
  ];

  const navigateMonth = (direction) => {
    const newDate = new Date(currentDate);
    newDate.setMonth(currentDate.getMonth() + direction);
    setCurrentDate(newDate);
  };

  const getEventsForDay = (day) => {
    if (!day) return [];
    const dateString = `${currentDate.getFullYear()}-${String(
      currentDate.getMonth() + 1
    ).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
    if (!Array.isArray(eventsCalendar)) {
      return [];
    }

    return eventsCalendar.filter((event) => {
      if (event.end_date) {
        const startDate = new Date(event.start_date);
        const endDate = new Date(event.end_date);
        const currentDate = new Date(dateString);
        return currentDate >= startDate && currentDate <= endDate;
      }
      return event.date === dateString;
    });
  };

  const handleSlideClick = (event) => {
   navigate(`/${event.link}`);
  };

  return (
    <div className="calendar-container">
      <div className="calendar-header">
        <div className="calendar-nav">
          <button onClick={() => navigateMonth(-1)} className="nav-button">
            <ChevronLeft />
          </button>
          <span className="current-month">
            {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
          </span>
          <button onClick={() => navigateMonth(1)} className="nav-button">
            <ChevronRight />
          </button>
        </div>
      </div>
      <div className="calendar-content">
        <div className="calendar-grid">
          {["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"].map((day) => (
            <div key={day} className="calendar-weekday">
              {day}
            </div>
          ))}
          {getMonthData().map((day, index) => (
            <div key={index} className="calendar-day">
              {day && (
                <>
                  <div className="day-number">{day}</div>
                  <div className="day-events">
                    {getEventsForDay(day).map((event) => (
                      <>
                        <div
                          className="conference-item-link"
                          onClick={() => handleSlideClick(event)}
                        >
                          <div className={`event-item ${event.type}`}>
                            {event.name}
                          </div>
                        </div>
                      </>
                    ))}
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default UtilsCalendar;
*/

import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "./UtilsCalendar.css";
import serverConfig from "../config";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const iconStart = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="currentColor"
    class="bi bi-align-start"
    viewBox="0 0 20 20"
  >
    <path
      fill-rule="evenodd"
      d="M1.5 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13a.5.5 0 0 1 .5-.5"
    />
    <path d="M3 7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z" />
  </svg>
);

const iconEnd = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="currentColor"
    class="bi bi-align-end"
    viewBox="0 0 20 20"
  >
    <path
      fill-rule="evenodd"
      d="M14.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 1 0v-13a.5.5 0 0 0-.5-.5"
    />
    <path d="M13 7a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1z" />
  </svg>
);

const iconGoTo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="currentColor"
    class="bi bi-link"
    viewBox="0 0 20 20"
  >
    <path d="M6.354 5.5H4a3 3 0 0 0 0 6h3a3 3 0 0 0 2.83-4H9q-.13 0-.25.031A2 2 0 0 1 7 10.5H4a2 2 0 1 1 0-4h1.535c.218-.376.495-.714.82-1z" />
    <path d="M9 5.5a3 3 0 0 0-2.83 4h1.098A2 2 0 0 1 9 6.5h3a2 2 0 1 1 0 4h-1.535a4 4 0 0 1-.82 1H12a3 3 0 1 0 0-6z" />
  </svg>
);

const iconCalendar = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="currentColor"
    class="bi bi-calendar"
    viewBox="0 0 20 20"
  >
    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
  </svg>
);

function UtilsCalendar() {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [eventsCalendar, setEventsCalendar] = useState([]);
  const [eventSelected, setEventSelected] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .post(`${serverConfig.serverUrl}/get_events_calendar`, {
        year: currentDate.getFullYear(),
        month: currentDate.getMonth() + 1,
      })
      .then((response) => {
        const data = response.data;
        setEventsCalendar(data);
      })
      .catch((error) => {});
  }, [currentDate]);

  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    return new Date(year, month + 1, 0).getDate();
  };

  const getFirstDayOfMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    return (new Date(year, month, 1).getDay() + 6) % 7;
  };

  const getMonthData = () => {
    const daysInMonth = getDaysInMonth(currentDate);
    const firstDayOfMonth = getFirstDayOfMonth(currentDate);
    const days = [];

    for (let i = 0; i < firstDayOfMonth; i++) {
      days.push(null);
    }

    for (let day = 1; day <= daysInMonth; day++) {
      days.push(day);
    }

    return days;
  };

  const monthNames = [
    "Gennaio",
    "Febbraio",
    "Marzo",
    "Aprile",
    "Maggio",
    "Giugno",
    "Luglio",
    "Agosto",
    "Settembre",
    "Ottobre",
    "Novembre",
    "Dicembre",
  ];

  const navigateMonth = (direction) => {
    const newDate = new Date(currentDate);
    newDate.setMonth(currentDate.getMonth() + direction);
    setCurrentDate(newDate);
  };

  const getEventsForDay = (day) => {
    if (!day) return [];
    const dateString = `${currentDate.getFullYear()}-${String(
      currentDate.getMonth() + 1
    ).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
    if (!Array.isArray(eventsCalendar)) {
      return [];
    }

    return eventsCalendar.filter((event) => {
      if (event.end_date) {
        const startDate = new Date(event.start_date);
        const endDate = new Date(event.end_date);
        const currentDate = new Date(dateString);
        return currentDate >= startDate && currentDate <= endDate;
      }
      return event.date === dateString;
    });
  };

  const handleSlideClick = (event) => {
    setEventSelected(event);
  };

  const goToLink = (event) => {
    navigate(`/${event.link}`);
  };

  const contentConferences = (
    <div className="calendar-container">
      <div style={{ padding: "10px" }}>
        <button
          onClick={() => setEventSelected(null)}
          style={{
            backgroundColor: "#E3E8EF",
            border: "2px solid #D8DEE9",
            borderRadius: "10px",
            height: "35px",
            width: "100%", // <- aggiunto
          }}
        >
          {iconCalendar}
          VISUALIZZA CALENDARIO
        </button>
      </div>
      {eventSelected && (
        <>
          <div style={{ padding: "10px" }}>
            <div>
              <h3>{eventSelected.name}</h3>
            </div>
            <div>
              {iconStart}
              {eventSelected.start_date}
            </div>
            <div>
              {iconEnd}
              {eventSelected.end_date}
            </div>
          </div>
          <div style={{ padding: "10px" }}>
            <button
              onClick={() => goToLink(eventSelected)}
              style={{
                backgroundColor: "#E3E8EF",
                border: "2px solid #D8DEE9",
                borderRadius: "10px",
                height: "35px",
                width: "100%", // <- aggiunto
              }}
            >
              {iconGoTo}
              VAI ALL'EVENTO
            </button>
          </div>
        </>
      )}
    </div>
  );

  return (
    <>
      {eventSelected ? (
        <>{contentConferences}</>
      ) : (
        <div className="calendar-container">
          <div className="calendar-header">
            <div className="calendar-nav">
              <button onClick={() => navigateMonth(-1)} className="nav-button">
                <ChevronLeft />
              </button>
              <span className="current-month">
                {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
              </span>
              <button onClick={() => navigateMonth(1)} className="nav-button">
                <ChevronRight />
              </button>
            </div>
          </div>
          <div className="calendar-content">
            <div className="calendar-grid">
              {["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"].map((day) => (
                <div key={day} className="calendar-weekday">
                  {day}
                </div>
              ))}
              {getMonthData().map((day, index) => (
                <div key={index} className="calendar-day">
                  {day && (
                    <>
                      <div className="day-number">{day}</div>
                      <div className="day-events">
                        {getEventsForDay(day).map((event) => (
                          <>
                            <div
                              className="conference-item-link"
                              onClick={() => handleSlideClick(event)}
                            >
                              <div className={`event-item ${event.type}`}>
                                {event.name}
                              </div>
                            </div>
                          </>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default UtilsCalendar;
